import { z } from 'zod'

import {
  ILandingPreview,
  ISidebarLink,
  ISortOption,
  Card
} from '../types/projectTypes'
import landingCardPlaceholder from '@/public/images/landingCardPlaceholder.png'
import { v4 as uuid } from 'uuid'
import {
  // LayoutDashboard,
  AppWindow,
  // ChartPie,
  Settings,
  // ChartCandlestick,
  // Building2,
  // TableOfContents,
  // File,
  // Folder,
  Copy,
  Edit,
  FolderOpen,
  Share2,
  Trash,
  Image,
  PencilLine,
  Palette,
  Type,
  StretchHorizontal,
  Calendar,
  Hash,
} from 'lucide-react'
import { IPredictionCard } from '@/components/analytics/AI-prediction/PredictionCard'
import { device_type } from '@/context/analytics-context/types'
import { AnalyticsIcon } from './crmicon'
//Hiding some navbar items for production environment

export const sidebarLinks: ISidebarLink[] = [
  // {
  //   title: 'Dashboard',
  //   path: 'dashboard',
  //   id: uuid(),
  //   icon: LayoutDashboard
  // },
  // {
  //   title: 'Landing Pages',
  //   path: 'landings',
  //   id: uuid(),
  //   icon: AppWindow
  // },
  {
    title: 'Web Pages',
    path: 'landings',
    id: uuid(),
    icon: AppWindow,
    iconOutlinedUrl: '/images/sidebar/browser-outlined.svg',
    iconFilledUrl: '/images/sidebar/browser-filled.svg',
    subLinks: [
      {
        title: 'Create Web Pages',
        path: 'landings',
        id: uuid()
      },
      // {
      //   title: 'Analytics',
      //   path: 'analytics',
      //   id: uuid(),
      // },
      {
        title: 'Speed Performance',
        path: 'analytics/speed-performance',
        id: uuid()
      },
      // {
      //   title: 'Click Stream',
      //   path: 'analytics/click-stream',
      //   id: uuid()
      // },
      {
        title: 'Regional Map',
        path: 'analytics/regional-maps',
        id: uuid()
      },
      {
        title: 'Heatmaps',
        path: 'analytics/heat-maps',
        id: uuid()
      },
      {
        title: 'Drop Off',
        path: 'analytics/drop-off',
        id: uuid()
      }
      // {
      //   title: 'User Behaviour',
      //   path: 'analytics/user-behaviour',
      //   id: uuid()
      // },
      // {
      //   title: 'Predictive Modeling',
      //   path: 'analytics/predictive-modeling',
      //   id: uuid()
      // }
    ]
  },

  {
    title: 'AI Design Center',
    path: 'ai-design-center/main',
    id: uuid(),
    icon: Image,
    iconOutlinedUrl: '/images/sidebar/image-AI-outlined.svg',
    iconFilledUrl: '/images/sidebar/image-AI-filled.svg',
    subLinks: [
      {
        title: 'Generate AI Image',
        path: 'ai-design-center/main',
        id: uuid()
      },
      {
        title: 'Manage Assets',
        path: 'ai-design-center/manage-assets',
        id: uuid()
      }
    ]
  },
  // {
  //   title: 'Assets',
  //   id: uuid(),
  //   path: 'assets',
  //   icon: ChartCandlestick,
  //   subLinks: [
  //     { title: 'Files', path: 'assets/files', id: uuid(), icon: File },
  //     { title: 'Folders', path: 'assets/folders', id: uuid(), icon: Folder }
  //   ]
  // },
  // {
  //   title: 'Management',
  //   path: 'management',
  //   id: uuid(),
  //   icon: Settings
  // },
  // {
  //   title: 'Campaign',
  //   path: 'campaign',
  //   id: uuid(),
  //   icon: Building2
  // },
  // {
  //   title: 'Content',
  //   path: 'content',
  //   id: uuid(),
  //   icon: TableOfContents
  // }
  {
    title: 'CRM',
    path: 'crm/main',
    id: 'crm-link',
    icon: AnalyticsIcon,
    iconOutlinedUrl: '/images/sidebar/chart-up-outlined.svg',
    iconFilledUrl: '/images/sidebar/chart-up-filled.svg',
    subLinks: [
      {
        title: 'Contacts',
        path: 'crm/main',
        id: uuid()
      },
      {
        title: 'Email Campaigns',
        path: 'crm/email-campaigns',
        id: uuid()
      },
      {
        title: 'Journeys',
        path: 'crm/journey',
        id: uuid()
      },
      {
        title: 'Tags',
        path: 'crm/tags',
        id: uuid()
      },
      {
        title: 'Custom Fields',
        path: 'crm/custom-fields',
        id: uuid()
      },
      {
        title: 'Email Templates',
        path: 'crm/email-templates',
        id: uuid()
      }
    ]
  },
  {
    title: 'Brand kits',
    path: 'brand-kits',
    id: uuid(),
    icon: Palette,
    iconOutlinedUrl: '/images/sidebar/palette-outlined.svg',
    iconFilledUrl: '/images/sidebar/palette-filled.svg'
  },
  {
    title: 'Calendar',
    path: 'cal/event-types',
    id: uuid(),
    icon: Calendar,
    iconOutlinedUrl: '/images/sidebar/calendar-outlined.svg',
    iconFilledUrl: '/images/sidebar/calendar-filled.svg',
    subLinks: [
      {
        title: 'Event Types',
        path: 'cal/event-types',
        id: uuid()
      },
      {
        title: 'Bookings',
        path: 'cal/bookings',
        id: uuid()
      },
      {
        title: 'Availability',
        path: 'cal/availability',
        id: uuid()
      },
      {
        title: 'Connections',
        path: 'cal/connections',
        id: uuid()
      },
    ]
  },
  {
    title: 'Settings',
    path: 'settings',
    id: uuid(),
    icon: Settings,
    iconOutlinedUrl: '/images/sidebar/settings-alt-outlined.svg',
    iconFilledUrl: '/images/sidebar/settings-alt-filled.svg'
  }
]

export const landingPagesSortOptions: ISortOption[] = [
  {
    title: 'Date created',
    value: 'created'
  },
  {
    title: 'Date updated',
    value: 'updated'
  },
  {
    title: 'Name A - Z',
    value: 'a-z'
  },
  {
    title: 'Name Z - A',
    value: 'z-a'
  }
]

export const landingPreviews: ILandingPreview[] = [
  {
    title: 'Landing Page 1',
    updateDate: new Date(),
    imageUrl: landingCardPlaceholder.src,
    subaccountId: '79baa551-5d1c-4637-a3ba-9ab274381a31',
    landingId: 'e64ca8b5-9a28-4573-a5fa-77c661bc483f',
    landingPageId: 'fe057e4a-0956-48b4-9f30-953595f5f9bb'
  },
  {
    title: 'Landing Page 2',
    updateDate: new Date(),
    imageUrl: landingCardPlaceholder.src,
    subaccountId: '79baa551-5d1c-4637-a3ba-9ab274381a31',
    landingId: 'e64ca8b5-9a28-4573-a5fa-77c661bc483f',
    landingPageId: 'fe057e4a-0956-48b4-9f30-953595f5f9bb'
  },
  {
    title: 'Landing Page 3',
    updateDate: new Date(),
    imageUrl: landingCardPlaceholder.src,
    subaccountId: '79baa551-5d1c-4637-a3ba-9ab274381a31',
    landingId: 'e64ca8b5-9a28-4573-a5fa-77c661bc483f',
    landingPageId: 'fe057e4a-0956-48b4-9f30-953595f5f9bb'
  },
  {
    title: 'Landing Page 4',
    updateDate: new Date(),
    imageUrl: landingCardPlaceholder.src,
    subaccountId: '79baa551-5d1c-4637-a3ba-9ab274381a31',
    landingId: 'e64ca8b5-9a28-4573-a5fa-77c661bc483f',
    landingPageId: 'fe057e4a-0956-48b4-9f30-953595f5f9bb'
  },
  {
    title: 'Landing Page 5',
    updateDate: new Date(),
    imageUrl: landingCardPlaceholder.src,
    subaccountId: '79baa551-5d1c-4637-a3ba-9ab274381a31',
    landingId: 'e64ca8b5-9a28-4573-a5fa-77c661bc483f',
    landingPageId: 'fe057e4a-0956-48b4-9f30-953595f5f9bb'
  }
]

export const industriesOptions = [
  { text: 'Marketing & Advertising', value: 'Marketing & Advertising' },
  {
    text: 'Financial Services (Fintech)',
    value: 'Financial Services (Fintech)'
  },
  {
    text: 'Education & Learning (Edtech)',
    value: 'Education & Learning (Edtech)'
  },
  { text: 'Artificial Intelligence', value: 'Artificial Intelligence' },
  { text: 'E-commerce & Retail', value: 'E-commerce & Retail' },
  { text: 'Logistics & Supply Chain', value: 'Logistics & Supply Chain' },
  { text: 'Healthcare & Wellness', value: 'Healthcare & Wellness' },
  { text: 'Real Estate', value: 'Real Estate' },
  { text: 'SaaS / Software', value: 'SaaS / Software' },
  { text: 'Media & Entertainment', value: 'Media & Entertainment' },
  { text: 'Other', value: 'Other' }
]

export const employeesOptions = [
  { text: '0-10', value: '0-10' },
  { text: '11-50', value: '11-50' },
  { text: '51-100', value: '51-100' },
  { text: '101-250', value: '101-250' },
  { text: '251-500', value: '251-500' },
  { text: '501-1000', value: '501-1000' },
  { text: '1001-5000', value: '1001-5000' },
  { text: '5000+', value: '5000+' }
]

export const waltzAIUseOptions = [
  {
    text: 'AI-Powered Web & Landing Pages',
    value: 'AI-Powered Web & Landing Pages'
  },
  { text: 'AI Image Generation', value: 'AI Image Generation' },
  { text: 'Analytics & AI prediction', value: 'Analytics & AI prediction' },
  { text: 'Email CRM & AI Campaigns', value: 'Email CRM & AI Campaigns' }
]

export const roleOptions = [
  { text: 'Marketing Manager', value: 'Marketing Manager' },
  { text: 'Product Manager', value: 'Product Manager' },
  { text: 'UI/UX Designer', value: 'UI/UX Designer' },
  { text: 'Software Developer', value: 'Software Developer' },
  {
    text: 'Content Creator / Freelancer',
    value: 'Content Creator / Freelancer'
  },
  { text: 'Social Media Manager', value: 'Social Media Manager' },
  { text: 'Business Owner / Founder', value: 'Business Owner / Founder' },
  { text: 'Other', value: 'Other' }
]

export const dataStorageLocationOptions = [
  { text: 'United States', value: 'us-west-1' },
  { text: 'Europe', value: 'eu-west-1' }
]

export const pricingCards = [
  {
    title: 'Basic Plan',
    priceStarts: 'From',
    price: '14$',
    duration: 'Per month',
    highlight: 'Key features',
    features: [
      'Up to 10 landing page per month',
      'Access to standard templates',
      'Basic AI A/b testing',
      'Email support'
    ],
    priceId: 'price_1OYxkqFj9oKEERu1KfJGWxgN'
  },
  {
    title: 'Business Plan',
    priceStarts: 'From',
    price: '45$',
    duration: 'Per month',
    highlight: 'Key features',
    features: [
      'Up to 50  landing page per month',
      'Access to premium templates',
      'Advanced AI A/b testing',
      'Comprehensive analytics',
      'Priority email support'
    ],
    priceId: 'price_1OYxkqFj9oKEERu1KfJGWxgN'
  },
  {
    title: 'Enterprise Plan',
    priceStarts: '',
    price: 'Contact sales',
    duration: '',
    highlight: 'Everything in Starter, plus',
    features: [
      'Unlimited content pieces',
      'Full suite of AI tools and integrations',
      'Full suite of AI tools and integrations',
      'Team collaboration features',
      'Priority phone and email support'
    ],
    priceId: ''
  }
]

export const ContactUserFormSchema = z.object({
  name: z.string().min(1, 'Required'),
  email: z.string().email()
})

export const menuOptions = [
  {
    label: 'Settings',
    icon: Settings,
    action: () => {},
    divider: true,
    disabled: true
  },
  { label: 'Edit', icon: Edit, action: () => {} },
  { label: 'Rename', icon: PencilLine, action: () => {} },
  { label: 'Duplicate', icon: Copy, action: () => {} },
  {
    label: 'Move to folder',
    icon: FolderOpen,
    action: () => {},
    disabled: true
  },
  { label: 'Share', icon: Share2, action: () => {}, disabled: true },
  { label: 'Delete', icon: Trash, action: () => {} }
]

export type dialogInfo = {
  type: string
  landingPageId: string
}

export const analyticsMapsTypes = [
  {
    identifier: 'heat_map',
    type: 'heatmaps',
    path: 'heat-maps',
    id: uuid(),
    name: 'Heatmaps'
  },
  {
    identifier: 'countries_regional_map',
    type: 'regionalmaps',
    path: 'regional-maps',
    id: uuid(),
    name: 'Regional Maps'
  }
]

export const DEFAULT_AGENCY_ID = 'b496696e-b63e-4365-9ed3-ee9f47b81b01'
export const DEFAULT_SUBACCOUNT_ID = '79baa551-5d1c-4637-a3ba-9ab274381a31'
export const DEFAULT_LANDING_ID = 'e64ca8b5-9a28-4573-a5fa-77c661bc483f'

export const NotFormData = ['button']

export const formDataAttributes = ['input', 'select', 'textarea']

export const analyticsPeriodFilterStates = [
  'last 7 days',
  'last month',
  'last year'
]

export const predictionColors = ['#FEF3E6', '#F5EEFF', '#FFFBE6', '#FFECF2']

export const predictionBgColors = ['#F5EEFF', '#FEF3E6', '#FFFBE6', '#FFECF2']
export const predictionIconColors = ['#9B56FE', '#F68601', '#FAD801', '#FF5C39']

export const speedPerformancePredictionData: IPredictionCard[] = [
  {
    heading: 'Page Load Time Prediction',
    aiPrediction:
      'Page load time on mobile is expected to increase by 0.3 seconds over the next week due to high traffic.',
    recommendation:
      'Optimize media files and use a CDN to improve mobile speed.',
    percentage: '+0.3s',
    bgColor: '#F5EEFF',
    iconBgColor: '#9B56FE'
  },
  {
    heading: 'Server Response Time Prediction',
    aiPrediction:
      'Desktop response times are predicted to improve by 0.1 seconds next week due to planned server upgrades in North America.',
    recommendation:
      'Notify users about upcoming maintenance windows to prevent traffic spikes.',
    percentage: '+0.1s',
    bgColor: '#FEF3E6',
    iconBgColor: '#F68601'
  },
  {
    heading: 'Time to First Byte (TTFB) Prediction',
    aiPrediction:
      'Desktop response times are predicted to improve by 0.1 seconds next week due to planned server upgrades in North America.',
    recommendation:
      'Notify users about upcoming maintenance windows to prevent traffic spikes.',
    percentage: '+0.1s',
    bgColor: '#FFFBE6',
    iconBgColor: '#FAD801'
  },
  {
    heading: 'User Engagement Prediction',
    aiPrediction:
      'Desktop drop-off rate are predicted to reduce by 10% next week due to planned server upgrades in North America.',
    recommendation:
      'Notify users about upcoming maintenance windows to prevent traffic spikes.',
    percentage: '+10%',
    bgColor: '#FFECF2',
    iconBgColor: '#FF5C39'
  }
]

export const clickStramPredictionData: IPredictionCard[] = [
  {
    heading: 'Clickstream Data',
    aiPrediction:
      'Page load time on mobile is expected to increase by 0.3 seconds over the next week due to high traffic',
    recommendation:
      'Optimize media files and use a CDN to improve mobile speed.',
    percentage: '+0.3s',
    bgColor: '#F4E8FF', // Light purple background
    iconBgColor: '#9B56FE'
  },
  {
    heading: 'Top Click Areas',
    aiPrediction:
      'Desktop response times are predicted to improve by 0.1 seconds next week due to planned server upgrades in North America',
    recommendation:
      'Notify users about upcoming maintenance windows to prevent traffic spikes.',
    percentage: '+0.1s',
    bgColor: '#FFF5E4',
    iconBgColor: '#F68601'
  }
]

export const predictiveModelPredictionData: IPredictionCard[] = [
  {
    heading: 'Traffic Rate',
    aiPrediction:
      'Desktop response data visits are Predicted to increase by 20% in the next 30 days.',
    recommendation:
      'Notify users about upcoming maintenance windows to prevent traffic spikes.',
    percentage: '+0.3s',
    bgColor: '#F5EEFF', // Light purple background
    iconBgColor: '#9B56FE'
  },
  {
    heading: 'Conversion Rate',
    aiPrediction:
      'Desktop response times are predicted to rise to 5% by the end of the month..',
    recommendation:
      'Notify users about upcoming maintenance windows to prevent traffic spikes.',
    percentage: '+0.1s',
    bgColor: '#FEF3E6', // Light orange background
    iconBgColor: '#F68601'
  }
]

export const userSegments: string[] = ['new', 'returning', 'returning Customer']

export const kpis: string[] = ['Traffic', 'Conversion Rate', 'Bounce Rate']

export const desktopFields = {
  label: 'Device type',
  key: 'device_type',
  placeholder: 'Select device type',
  options: [
 
    {
      label: 'Desktop',
      value: device_type.desktop
    },
    {
      label: 'Tablet',
      value: device_type.tab
    },
    {
      label: 'Mobile',
      value: device_type.mobile
    }
  ],
  metaData: ['desktop', 'tab', 'tablet', 'mobile', 'device type', 'all devices']
}

export const userSegmentsFields = {
  label: 'User segments',
  key: 'user_segment',
  placeholder: 'Select user segment',
  options: userSegments.map(item => ({ label: item, value: item })),
  metaData: [
    'User segments',
    'user_segment',
    ...userSegments.map(userSegment => userSegment.toLowerCase())
  ]
}

export const countries = [{ value: 'germany', label: 'Germany' }]

export const trafficSources: string[] = [
  'direct',
  'website',
  'search',
  'social',
  'campaign'
]

export const trafficSourcesFields = {
  label: 'Traffic source',
  key: 'traffic_source',
  placeholder: 'Select traffic source',
  options: trafficSources.map(item => ({ label: item, value: item })),
  metaData: [
    'traffic source',
    ...trafficSources.map(trafficSource => trafficSource.toLowerCase())
  ]
}

export const kpisFields = {
  label: 'KPIs',
  key: 'kpi',
  placeholder: 'Select KPI',
  options: kpis.map(item => ({ label: item, value: item })),
  metaData: ['kpis', ...kpis.map(kpi => kpi.toLowerCase())]
}

export const userBehaviourPredictionData: IPredictionCard[] = [
  {
    heading: 'Drop-off Rate Prediction',
    aiPrediction:
      'The drop-off rate is predicted to increase by 25% due to upcoming changes in user behavior patterns.',
    recommendation:
      'Implement personalized content strategies to reduce drop-offs and enhance user engagement.',
    percentage: '+25%',
    bgColor: '#F5EEFF' // Light purple background
  },
  {
    heading: 'Conversion Rate Prediction',
    aiPrediction:
      'The conversion rate is predicted to increase by 25% based on the analysis of recent marketing efforts.',
    recommendation:
      'Focus on optimizing landing pages and ensuring seamless checkout experiences.',
    percentage: '+25%',
    bgColor: '#FEF3E6', // Light orange background
    iconBgColor: '#F68601'
  }
]

// export const userBehaviourPredictionData: IPredictionCard[] = [
//   {
//     heading: 'Drop-off Rate Prediction',
//     aiPrediction:
//       'The drop-off rate is predicted to increase by 25% due to upcoming changes in user behavior patterns.',
//     recommendation:
//       'Implement personalized content strategies to reduce drop-offs and enhance user engagement.',
//     percentage: '+25%',
//     bgColor: '#F5EEFF' // Light purple background
//   },
//   {
//     heading: 'Conversion Rate Prediction',
//     aiPrediction:
//       'The conversion rate is predicted to increase by 25% based on the analysis of recent marketing efforts.',
//     recommendation:
//       'Focus on optimizing landing pages and ensuring seamless checkout experiences.',
//     percentage: '+25%',
//     bgColor: '#FEF3E6' // Light orange background
//   },
//   {
//     heading: 'Engagement Time Prediction',
//     aiPrediction:
//       'Engagement time is expected to rise by 25% due to improved content and UI updates.',
//     recommendation:
//       'Continue to refine content strategies and invest in interactive elements.',
//     percentage: '+25%',
//     bgColor: '#FFFBE6' // Light yellow background
//   },
//   {
//     heading: 'Click-through Rate (CTR) Prediction',
//     aiPrediction:
//       'Click-through rates are anticipated to improve by 25% due to the introduction of new targeted campaigns.',
//     recommendation:
//       'Enhance targeting strategies and improve ad copy for better engagement.',
//     percentage: '+25%',
//     bgColor: '#FFECF2' // Light red/pink background
//   }
// ]

export const reasonsOfDeletion: { value: string; text: string }[] = [
  {
    value: 'I no longer need a landing page builder or analytics tools.',
    text: 'I no longer need a landing page builder or analytics tools.'
  },
  {
    value: "The features didn't meet my expectations.",
    text: "The features didn't meet my expectations."
  },
  {
    value: 'The pricing is too expensive for my needs.',
    text: 'The pricing is too expensive for my needs.'
  },
  {
    value: 'My company decided to use a different solution.',
    text: 'My company decided to use a different solution.'
  },
  {
    value: 'The learning curve was too steep or required too much effort',
    text: 'The learning curve was too steep or required too much effort'
  },
  {
    value:
      'The platform was difficult to use or lacked essential integrations.',
    text: 'The platform was difficult to use or lacked essential integrations.'
  },
  { value: 'Other', text: 'Other' }
]

export const countriesList: Record<string, string> = {
  AF: 'Afghanistan',
  AX: 'Aland Islands',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua And Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia',
  BA: 'Bosnia And Herzegovina',
  BW: 'Botswana',
  BV: 'Bouvet Island',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  CV: 'Cape Verde',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands',
  CO: 'Colombia',
  KM: 'Comoros',
  CG: 'Congo',
  CD: 'Congo, Democratic Republic',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  CI: 'Cote D"Ivoire',
  HR: 'Croatia',
  CU: 'Cuba',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Ethiopia',
  FK: 'Falkland Islands (Malvinas)',
  FO: 'Faroe Islands',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  TF: 'French Southern Territories',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard Island & Mcdonald Islands',
  VA: 'Holy See (Vatican City State)',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran, Islamic Republic Of',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle Of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KR: 'Korea',
  KP: 'North Korea',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: 'Lao People"s Democratic Republic',
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libyan Arab Jamahiriya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MK: 'Macedonia',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia, Federated States Of',
  MD: 'Moldova',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  AN: 'Netherlands Antilles',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestinian Territory, Occupied',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  RE: 'Reunion',
  RO: 'Romania',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  BL: 'Saint Barthelemy',
  SH: 'Saint Helena',
  KN: 'Saint Kitts And Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin',
  PM: 'Saint Pierre And Miquelon',
  VC: 'Saint Vincent And Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome And Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  GS: 'South Georgia And Sandwich Isl.',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard And Jan Mayen',
  SZ: 'Swaziland',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syrian Arab Republic',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TZ: 'Tanzania',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad And Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks And Caicos Islands',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  US: 'United States',
  UM: 'United States Outlying Islands',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela',
  VN: 'Vietnam',
  VG: 'Virgin Islands, British',
  VI: 'Virgin Islands, U.S.',
  WF: 'Wallis And Futuna',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe'
}

export const selfServiceCards: Card[] = [
  {
    title: 'Basic',
    description: 'For startups and organizations',
    monthlyPrice: '$24.99',
    yearlyPrice: '$249.99',
    isHighlighted: false,
    buttonText: 'Start Today',
    freeTrialButtonText: '14 Day Free Trial',
    features: [
      '500 monthly credits',
      'AI-powered Page Generation',
      'AI Design Center+ for smart editing',
      'Brand Kits',
      'Analytics',
      'CRM / Lead Management'
    ]
  },
  // {
  //   title: 'Pro',
  //   description: 'For large organizations',
  //   monthlyPrice: '$99.99',
  //   yearlyPrice: '$83.33',
  //   isHighlighted: true,
  //   features: [
  //     'Up to 10 landing page/month',
  //     'Access to standard templates',
  //     'Basic AI A/b testing',
  //     'Email support',
  //     '24/7 Live Chat Support',
  //     '10,000 emails/month'
  //   ]
  // },
  {
    title: 'Business Trial',
    description: 'Automatically renews at $24.99/month after 3 months',
    monthlyPrice: '$9.99',
    yearlyPrice: '$249.99',
    isHighlighted: false,
    buttonText: 'Start Today',
    features: [
      '500 monthly credits',
      'AI-powered Page Generation',
      'AI Design Center+ for smart editing',
      'Brand Kits',
      'Analytics',
      'CRM / Lead Management'
    ],
    // priceNote: 'First 3 months, then $49.99/month'
    priceNote: 'for 3 months'
  },
  {
    title: 'Pro',
    description: 'Designed for growth and advanced workflows',
    monthlyPrice: '$49.99',
    yearlyPrice: '$549.99',
    isHighlighted: false,
    buttonText: 'Start Today',
  features: [
      'Including 1000 credits',
      'Multi User Workspace',
      'Analytics Reports (PDF Download)',
      'Email Journeys Builder',
      'Email Campaign manager',
      'Booking module (Calendar)'
    ]
    // priceNote: 'First 3 months, then $49.99/month'
  },
  {
    title: 'Enterprise',
    description: 'Custom solution to your needs',
    isHighlighted: false,
    features: [
      'Up to 10 landing page/month',
      'Access to standard templates',
      'Basic AI A/b testing',
      'Email support',
      '24/7 Live Chat Support'
    ],
    isEnterprise: true
  }
]

export const managedServiceCards: Card[] = [
  {
    title: 'Enterprise',
    description: 'Best suited for growing businesses with expanding needs.',
    buttonText: 'Get Enterprise',
    monthlyPrice: '$1000',
    yearlyPrice: '$4,800',
    features: [
      'Up to 10 landing page/month',
      'Access to standard templates',
      'Basic AI A/b testing',
      'Email support',
      '24/7 Live Chat Support'
    ],
    isHighlighted: false
  },
  {
    title: 'White Label',
    description: 'Best suited for growing businesses with expanding needs.',
    buttonText: 'Get White Label',
    features: [
      'Up to 10 landing page/month',
      'Access to standard templates',
      'Basic AI A/b testing',
      'Email support',
      '24/7 Live Chat Support'
    ],
    isHighlighted: false
  }
]

export const fieldModalConfig = {
  title: 'Add New Field',
  description:
    'Here, you can add new inputs that will be automatically synced between your CRM and Forms. Once you add an input, it will be reflected in the Leads table and the Forms section within the Landing Page Builder, ensuring seamless data integration across both platforms.',

  fields: [
    {
      id: 'fieldType',
      label: 'Field Type',
      type: 'select',
      placeholder: 'Select from list below',
      helpText:
        'Choose the type of input field you want to create, such as text, date, or number.',
      options: [
        { value: 'text', label: 'Text' },
        { value: 'dateTime', label: 'Date & Time' },
        { value: 'dateRange', label: 'Date Range' },
        { value: 'number', label: 'Number' },
        { value: 'location', label: 'Location' },
        { value: 'link', label: 'Link' },
        { value: 'image', label: 'Image' }
      ]
    },
    {
      id: 'fieldName',
      label: 'Field Name',
      type: 'text',
      placeholder: 'ex. Date of Birth',
      helpText:
        "Give the field a name (e.g., 'Date of Birth') to identify it within your CRM and forms."
    },
    {
      id: 'fieldLabel',
      label: 'Field Label',
      type: 'text',
      placeholder: 'Provide your label text',
      helpText:
        "Enter the label text that will appear next to the field on the form (e.g., 'Your Date of Birth')."
    },
    {
      id: 'fieldPlaceholder',
      label: 'Field Placeholder',
      type: 'text',
      placeholder: 'Provide your placeholder text',
      helpText:
        "Provide a hint or example text that will appear inside the input field to guide users (e.g., 'MM/DD/YYYY')."
    }
  ]
}

export const filedFilterOptions = [
  { type: 'EQUALS', label: 'Equal To' },
  { type: 'NOT_EQUALS', label: 'Not Equal To' },
  { type: 'CONTAINS', label: 'Contains' },
  { type: 'NOT_CONTAIN', label: 'Not Contain' },
  { type: 'STARTS_WITH', label: 'Starts With' },
  { type: 'ENDS_WITH', label: 'Ends With' },
  { type: 'IS_NULL', label: 'Is Blank' },
  { type: 'IS_NOT_NULL', label: 'Is Not Blank' }
]

export const customFieldTypeOptions = [
  { text: 'Yes/No', value: 'Boolean', icon: Hash, tooltipText: 'For simple toggle fields' },
  { text: 'Date', value: 'Date', icon: Calendar, tooltipText: 'For selecting calendar-based data' },
  { text: 'DropDown', value: 'DropDown', icon: StretchHorizontal, tooltipText: 'Predefined list of choices' },
  { text: 'Number', value: 'Number', icon: Hash, tooltipText: 'Numerical input only' },
  // { text: 'Selector', value: 'Selector', icon: ChevronDown, tooltipText: 'For multi-select fields (up to 5 options)' },
  { text: 'String', value: 'String', icon: Type, tooltipText: 'Free text (letters and numbers)' }
]

export const customFieldCreatedMethodOptions = [
  { text: 'Custom', value: 'Custom' },
  { text: 'System', value: 'System' }
]

export const proModalConfig = {
  Journeys: {
    title: 'Build your own journeys',
    imageSrc: '/images/proplan/JourneyProModalImage.png'
  },
  'Custom Fields': {
    title: 'Create and manage custom fields',
    imageSrc: '/images/proplan/CustomProPlanModalImage.png'
  }
}
